export default __webpack_public_path__ + "static/parks_canada.b30cd5b25ec37d86e4313630ade9d334.jpg";